import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api/salaires`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('finance_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const salairesApi = {
  getSalaries: (params) => api.get('/', { params }),
  getOrgMetrics: () => api.get('/org-metrics'),
  getMasseSalariale: (params) => api.get('/masse-salariale', { params }),
  importAgregats: (formData) => api.post('/import-agregats', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  createSalarie: (data) => api.post('/', data),
  updateSalarie: (id, data) => api.put(`/${id}`, data),
  deleteSalarie: (id) => api.delete(`/${id}`),

  getDetails: (params) => api.get('/details', { params }),
  saveDetail: (data) => api.put('/details', data),

  getTypesCharges: () => api.get('/types-charges'),
  createTypeCharge: (data) => api.post('/types-charges', data),
  updateTypeCharge: (id, data) => api.put(`/types-charges/${id}`, data),
  deleteTypeCharge: (id) => api.delete(`/types-charges/${id}`),

  deleteDetailsBulk: (params) => api.delete('/details/bulk', { params }),

  getTotalVerse: (params) => api.get('/total-verse', { params }),
  saveTotalVerse: (data) => api.put('/total-verse', data),

  getCoefficient: () => api.get('/config/coeff'),
  saveCoefficient: (coeff) => api.put('/config/coeff', { coeff }),
  getDashboard: (params) => api.get('/dashboard', { params }),
  exportExcel: (params) => api.get('/export', { params, responseType: 'blob' }),
  importPdf: (data) => api.post('/import-pdf', data),

  getMoisType: (params) => api.get('/mois-type', { params }),
  saveMoisType: (data) => api.put('/mois-type', data),
  extendPrevisions: (data) => api.post('/previsions/extend', data),

  reorderOrg: (items) => api.put('/reorder-org', { items }),
  getContratElements: (params) => api.get('/contrat-elements', { params }),
  saveContratElement: (data) => api.put('/contrat-elements', data),
  deleteContratElement: (id) => api.delete(`/contrat-elements/${id}`),

  getLicenciements: () => api.get('/licenciements'),
  createLicenciement: (data) => api.post('/licenciements', data),
  updateLicenciement: (id, data) => api.put(`/licenciements/${id}`, data),
  deleteLicenciement: (id) => api.delete(`/licenciements/${id}`),
};

export default salairesApi;
